angular.module('elfium').filter('elfiumDaterange', function () {
	var that = this;
	that.hasDateFilters = function (dateFilters) {
		var has = false;
		for (var key in dateFilters) {
			if (dateFilters[key].startDate || dateFilters[key].endDate) {
				has = true;
				break;
			}
		}
		return has;
	};
    return function (objectList, dateFilters) {
        var resultList = [];
        if (that.hasDateFilters(dateFilters)) {
        	angular.forEach(dateFilters, function (filter, fieldName) {
	        	angular.forEach(objectList, function (currentObject) {
	        		if (moment(currentObject[fieldName]).isBetween(filter.startDate, filter.endDate, null, '[]')) {
	        			resultList.push(currentObject);
	        		}
	        	});
	        });	
        } else {
        	resultList = objectList;
        }        
        return resultList;
    }
});


// WEBPACK FOOTER //
// ./src/app/components/elfium/elfiumDaterange.ts